import './Footer2.css';

const Footer2 = (props) => {
    return <div className='footer2'>
    Create by Silvio c bonfim
</div>
};


export default Footer2;